import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import surendra from '../assets/images/surendra (1).jpeg';
import madhuvu from '../assets/images/madhuvu.png';
const testimonials = [
  {
    name: "Madhuvu",
    location: "KnackHook ",
    img: madhuvu,
    rating: 5,
    text: "The IT consulting team at *Saha Infotechs* helped us fill critical open positions with skilled professionals. Their training programs were instrumental in developing our team's skills, leading to improved project outcomes."
  },
  {
    name: "Surendra",
    location: "SigninSoft",
    img: surendra,
    rating: 5,
    text: "Working with *Saha Infotechs* was a game-changer. Their consultants provided tailored training to our staff, enhancing their technical expertise and empowering them to tackle complex challenges."
  },
  {
    name: "Madhuvu",
    location: "KnackHook ",
    img: madhuvu,
    rating: 5,
    text: "The IT consulting team at *Saha Infotechs* helped us fill critical open positions with skilled professionals. Their training programs were instrumental in developing our team's skills, leading to improved project outcomes."
  },
  {
    name: "Surendra",
    location: "SigninSoft",
    img:surendra,
    rating: 5,
    text: "Working with *Saha Infotechs* was a game-changer. Their consultants provided tailored training to our staff, enhancing their technical expertise and empowering them to tackle complex challenges."
  },
];

const Testimonials = () => {
  return (
    <div id='Testimonials'>
      <section className="testimonials-section sec-padd">
        <div className="container">
          <div className="section-title center">
            <h2>Testimonials</h2>
          </div>

          <OwlCarousel
            className="owl-theme"
            loop
            margin={30}
            autoplay
            autoplayTimeout={5000}
            nav
            dots={false}
            responsive={{
              0: { items: 1 },
              600: { items: 2 },
              // 1000: { items: 3 }
            }}
          >
            {testimonials.map((testimonial, index) => (
              <article key={index} className="slide-item" style={{height:'350px'}}>
                <div className="quote"><span className="icon-left"></span></div>
                <div className="author">
                  <div className="img-box">
                    <img src={testimonial.img} alt={testimonial.name} />
                  </div>
                  <h4>{testimonial.name}</h4>
                  <p>{testimonial.location}</p>
                  <div className="rating">
                    {Array(testimonial.rating).fill().map((_, i) => (
                      <span key={i} className="fa fa-star"></span>
                    ))}
                  </div>
                </div>
                <div className="slide-text">
                  <p>{testimonial.text}</p>
                </div>
              </article>
            ))}
          </OwlCarousel>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
